import React, { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Button, Col, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import MakeInvoiceService from "../../../../service/billing/invoice/makeInvoiceService"
import { TInvoiceSeikyuSimePostReq } from "../../../../service/billing/invoice/TInvoice"
import util from "../../../../ts/util"
import pageHelper from "../../../../ts/helpers/pageHelper"

// Kairos
import { AppDispatch } from "../../../.."
import { setAlerts } from "../../../../globalStore/alertStore"
import { showInfoToast } from "../../../../components/CustomToast"
import Spinner from "../../../../components/Spinner"

const MakeInvoiceExecModal: React.FC<
  TModalTypes & {
    請求年月?: string | null
    締日区分?: string | null
    荷主請求IdList: number[]
    isExecSime: boolean
    setIsExecSime: (value: boolean) => unknown
  }
> = (props) => {
  const history = useHistory()
  const location = useLocation()

  const [isSearching, setIsSearching] = useState(false)

  //#region [method]
  /*
   * 請求締め処理
   * @param seikyuSimeCondition 請求締め処理実行条件
   */
  const seikyuSime = async (
    seikyuSimeCondition?: TInvoiceSeikyuSimePostReq
  ) => {
    let currentSeikyuSimeCondition: TInvoiceSeikyuSimePostReq
    // 実行条件生成
    if (seikyuSimeCondition) {
      // 引数の実行条件を使用
      currentSeikyuSimeCondition = seikyuSimeCondition
    } else {
      // stateから実行条件を生成
      currentSeikyuSimeCondition = createSeikyuSimeCondition()
    }
    // QueryStringに実行条件を反映
    pageHelper.pushQuery(history, location, currentSeikyuSimeCondition)

    try {
      await new MakeInvoiceService().seikyuSime(currentSeikyuSimeCondition)

      showInfoToast(`請求締め処理が完了しました`)
    } catch (error) {
      dispatch(setAlerts(error))
      throw error
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 請求締め処理実行条件オブジェクトを生成
   */
  const createSeikyuSimeCondition = (): TInvoiceSeikyuSimePostReq => {
    return {
      請求年月: props.請求年月 ?? undefined,
      締日区分: props.締日区分 ?? undefined,
      荷主請求IdList: [...props.荷主請求IdList],
    }
  }
  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [state]

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      isDisabledCloseButton={isSearching}
      size={props.size}>
      <Spinner searching={isSearching} inModal={true}></Spinner>
      <div>
        {util.date.format(props.請求年月, "YYYY/MM")}{" "}
        　請求締め処理を実行します。
      </div>
      <Row className="search-button">
        <Col className="text-center">
          <Button
            className="w-9rem"
            variant="waiting"
            type="submit"
            onClick={async (e) => {
              e.stopPropagation()
              e.preventDefault()
              setIsSearching(true)
              try {
                await seikyuSime()
                props.setIsExecSime(true)
              } finally {
                props.setIsShow(false)
              }
            }}>
            実行
          </Button>
        </Col>
      </Row>
    </ModalOuter>
  )
}

export default MakeInvoiceExecModal
